(function () {
    const isRTL = getComputedStyle(document.body).direction === "rtl";

    const initScrollProducts = () => {
        const sections = document.querySelectorAll(".section-scroll-products");

        sections.forEach((section) => {
            if (section.classList.contains("scroll_initialized")) return;
            section.classList.add("scroll_initialized");

            const parent = section.querySelector(".scroll-products__container");
            const child = section.querySelector(".scroll-products");
            const innerDiv = child.querySelector(".scroll-products__products");
            const productCard = section.querySelector(".scroll-products__item");
            const wrapper = section.querySelector(".scroll-products__wrapper");
            const productsCount = +child.dataset.productsCount;
            const isSingleProduct = productsCount === 1;
            const childBefore = window.getComputedStyle(child, "::before");
            const slideHeight = parseFloat(childBefore.height);

            const updateMinHeight = () => {
                if (productCard) {
                    wrapper.style.maxHeight = `${productCard.offsetHeight}px`;
                    let productCardHeight = productCard.offsetHeight + 96;
                    if (productCardHeight < slideHeight) productCardHeight = slideHeight;
                    if (parseInt(child.style.minHeight) !== productCardHeight) {
                        child.style.minHeight = `${productCardHeight}px`;
                    }
                }
            };
            updateMinHeight();

            if (!parent || !child || !innerDiv) return;

            let ticking = false;

            const handleScroll = () => {
                if (ticking) return;
                ticking = true;
                window.requestAnimationFrame(() => {
                    const windowWidth = window.innerWidth;
                    const isSmallScreen = windowWidth < 990;
                    const isMediumScreen = windowWidth < 1360;

                    if (!isSmallScreen) {
                        // ===== Desktop Mantığı =====
                        const parentRect = parent.getBoundingClientRect();
                        const childRect = child.getBoundingClientRect();
                        const startScroll = parentRect.top + window.scrollY;
                        const endScroll = parentRect.bottom - childRect.height + window.scrollY;
                        const scrolled = Math.min(Math.max((window.scrollY - startScroll) / (endScroll - startScroll), 0), 1);

                        let translateY = -115 + 110 * scrolled;
                        let translateX = -50;

                        if (productsCount === 4) {
                            translateY = -50;
                            translateX = !isMediumScreen ? 70 - 70 * scrolled : 76 - 76 * scrolled;
                        } else if (productsCount !== 4 && !isSingleProduct) {
                            translateY = -50;
                            translateX = !isMediumScreen ? 60 - 60 * scrolled : 67 - 67 * scrolled;
                        } else if (isSingleProduct) {
                            translateX = 0;
                            translateY = -50 * scrolled;
                        }

                        innerDiv.style.transform = `translate(${isRTL ? -translateX : translateX}%, ${translateY}%)`;

                    } else {
                        // ===== Mobil / Küçük ekran mantığı =====
                        const parentWidth = parent.offsetWidth;
                        const contentWidth = innerDiv.scrollWidth;
                        const extraOffset = 800; // son üründen sonra ekstra kaydırma
                        const scrollableWidth = Math.max(contentWidth - parentWidth + extraOffset, 0);

                        const parentRect = parent.getBoundingClientRect();
                        const startScroll = parentRect.top + window.scrollY;
                        const endScroll = parentRect.bottom + window.scrollY;

                        let scrolled = (window.scrollY - startScroll) / (endScroll - startScroll);
                        scrolled = Math.min(Math.max(scrolled, 0), 1);

                        const initialOffset = -400; // <-- Burayı artırdık, ilk öğe daha sağda başlasın
                        let translateX = -scrollableWidth * scrolled - initialOffset; // sola kayma

                        let translateY = -50; // sabit dikey pozisyon

                        innerDiv.style.transform = `translate(${translateX}px, ${translateY}%)`;
                    }

                    ticking = false;
                });
            };

            const handleResize = () => {
                updateMinHeight();
                handleScroll();
            };

            window.addEventListener("scroll", handleScroll);
            window.addEventListener("resize", handleResize);

            handleScroll();
        });
    };

    initScrollProducts();
    document.addEventListener("shopify:section:load", () => {
        initScrollProducts();
    });
})();
